import React, { useState, useEffect } from 'react';

import TimeGraphsModule from '../modules/TimeGraphsModule';
import './Box.css';

const QiTimesGraphsBox = ({user, isSmallScreen}) => {

    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>

            <h4></h4>

            <TimeGraphsModule
                user={user}
                isSmallScreen={isSmallScreen}
            />

        </div>
    );
};

export default QiTimesGraphsBox;

